import * as Api from '@ViewModels';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'CustomPageStyle/{type}';

export const useFindOrCreateBlogStylesByTypeQuery = ({
	type,
	impersonationContext,
	enabled,
	meta,
}: {
	type: Api.CustomPageType;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	allowedClasses?: string[];
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			const value = await userSession.webServiceHelper.callAsync<Api.CustomBlogStyles>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `CustomPageStyle/${encodeURIComponent(type)}`,
					impersonationContext,
				}),
				'POST'
			);
			return value;
		},
		queryKey: [BASE_QUERY_KEY, type, impersonationContext],
		staleTime: 30000,
		placeholderData: keepPreviousData,
		meta,
	});
};

export const invalidateAllFindOrCreateBlogStylesByTypeQueries = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};

export const invalidateFindOrCreateBlogStylesByTypeQueries = (type: Api.CustomPageType) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, type] });
};
